import { useTrainingMutations } from '@/app/hooks/useTrainingMutations'
import { Button } from '@/view/components/ui/button'
import { DialogContent } from '@/view/components/ui/dialog'
import { CircleAlert } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useDeleteTrainingContext } from '../../providers/DeleteTrainingProvider'

interface DeleteTrainingProps {
  trainingId: string
}

export const DeleteTraining = ({ trainingId }: DeleteTrainingProps) => {
  const { deleteTraining, isDeleting } = useTrainingMutations()
  const { setIsDeleteTrainingModalOpen } = useDeleteTrainingContext()
  const navigate = useNavigate()

  const handleDelete = async () => {
    try {
      await deleteTraining(trainingId)
      navigate('/conteudos/gerenciar?tab=training')
      setIsDeleteTrainingModalOpen(false)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <DialogContent>
      <div className="flex w-full items-center justify-center">
        <CircleAlert className="text-destructive" size={52} />
      </div>
      <p className="mb-2 text-center text-xl">
        Deseja deletar todo o conteúdo do treinamento?
      </p>
      <div className="flex justify-end space-x-4">
        <Button
          size="lg"
          onClick={handleDelete}
          disabled={isDeleting}
          className="w-full rounded-full bg-transparent text-primary hover:bg-primary/10"
        >
          Sim, deletar tudo
        </Button>
        <Button
          size="lg"
          className="w-full rounded-full bg-primary text-white"
          onClick={() => setIsDeleteTrainingModalOpen(false)}
        >
          Não, Cancelar
        </Button>
      </div>
    </DialogContent>
  )
}
